export default "__VITE_ASSET__DKnnwQjw__"